import React, { useState } from 'react';
import { ListGroup, Form, Modal, Alert } from 'react-bootstrap';
import { useCreateDataset } from './hooks/UseDatasets';
import { Dataset } from './api/Application';
import { BsDatabase } from 'react-icons/bs';
import { Button } from './components/Button';
import { DatasetItem } from "./DatasetListPageDatasetItem";
import { DatasetStats } from "./DatasetListPageDatasetStats";
import { useLoaderData } from "react-router-dom";

export function DatasetListPage() {
    const datasets = useLoaderData() as Dataset[];
    const createDataset = useCreateDataset();
    const [show, setShow] = useState( false );
    const [name, setName] = useState( '' );
    const [desc, setDesc] = useState( '' );
    const [selectedDataset, setSelectedDataset] = useState<Dataset | null>( null );

    const handleCreate = () => {
        createDataset.mutate( { name, description: desc }, {
            onSuccess: () => {
                setShow( false );
                setName( '' );
                setDesc( '' );
            }
        } );
    };

    const handleDatasetClick = ( dataset: Dataset ) => {
        if( dataset.datasetId === selectedDataset?.datasetId ) return;
        setSelectedDataset( dataset );
    };

    // Select first dataset by default when data loads
    React.useEffect( () => {
        if( datasets && datasets.length > 0 && !selectedDataset ) {
            setSelectedDataset( datasets[0] );
        }
    }, [datasets, selectedDataset] );

    return (
        <div id="capture-list-page">
            <div id="capture-list">
                <div className="bg-body-tertiary d-flex flex-row w-100 justify-content-center align-items-center gap-2 p-2">
                    <div className="flex-grow-1 ps-2 fs-5">
                        Datasets
                    </div>
                    <Button size="sm" onClick={() => setShow( true )}>
                        Create Dataset
                    </Button>
                </div>
                <div className="y-scroll-auto">
                    <ListGroup variant="flush">
                        {datasets?.map( ( dataset ) => (
                            <DatasetItem
                                key={dataset.datasetId}
                                dataset={dataset}
                                onClick={() => handleDatasetClick( dataset )}
                                isSelected={selectedDataset?.datasetId === dataset.datasetId}
                            />
                        ) )}
                    </ListGroup>
                </div>
            </div>

            <div className="image-viewer h-100" style={{
                overflow: 'auto',
                position: 'relative',
            }}>
                {selectedDataset ? (
                    <DatasetStats dataset={selectedDataset} />
                ) : (
                    <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                        <div className="text-center">
                            <BsDatabase style={{ fontSize: '64px' }} className="mb-3" />
                            <p>Select a dataset to view details</p>
                        </div>
                    </div>
                )}
            </div>

            <Modal show={show} onHide={() => setShow( false )}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Dataset</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            value={name}
                            onChange={e => setName( e.target.value )}
                            placeholder="Enter dataset name"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={desc}
                            onChange={e => setDesc( e.target.value )}
                            placeholder="Enter dataset description (optional)"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow( false )}>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleCreate}
                        disabled={!name.trim() || createDataset.isPending}>
                        {createDataset.isPending ? 'Creating...' : 'Create'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}